import React from 'react'
import { getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { Button, Icon } from 'semantic-ui-react'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { 
  StdCard,
} from 'components'

const FinalContract = (props) => {

  const {
    valueForm,
  } = props

  const getFinalContract = () =>{
    if(valueForm&&valueForm.attachments){
      let file = valueForm.attachments.find(x=>x.documentType.toLowerCase()=='ct09'&&x.deleted==false)
      return file||null
    }
  }

  return (
    <React.Fragment>
    {valueForm&&valueForm.status==4?
      <ProcurementBody>
        <StdCard title='Final Signed Contract File' style={{ marginTop: '10px' }}>
          {getFinalContract()?
            // <Button icon labelPosition='right' onClick={()=>window.open(getFinalContract().urlPath)}>
            <Button icon labelPosition='right' onClick={()=>window.location.href = getFinalContract().urlPath}>
              Download Final Signed Contract File
              <Icon name='download' />
            </Button>
            :
            <div style={{color:'red', fontSize:'1.5rem', fontWeight:'bold'}}>
              Please contact administrator
            </div>
          }
        </StdCard>
      </ProcurementBody>
      :
      null
    }
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formContract')(state),
})

const mapDispatchToProps = ({
  
})

export default connect(mapStateToProps, mapDispatchToProps)(FinalContract)